export default __webpack_public_path__ + "static/media/image.19dc954b.webp";